class Server {
  constructor(hostname, environment) {
    // local
    let env = "dev";
    let api = "http://localhost:9000/v1";

    // test, int, or qa
    if (environment) {
      env = environment;
      api = "https://" + env + ".mc10cloud.com/api/v1";
    }
    // other mc10 domain
    else if (/mc10cloud.com$/.test(hostname)) {
      env = (hostname.match(/^(\w+).mc10cloud.com/) || [])[1];
      env = env === undefined || env === "www" ? "prod" : env;
      api = "https://" + hostname + "/api/v1";
    }

    this.ENV = env;
    this.API = api;
  }
}

module.exports = Server;